import { Button } from '$components'

type PaymentMethodType = {
  last4: string
  expiryDate: string
}

type PaymentMethodProps = {
  data: PaymentMethodType
}

export function PaymentMethod({ data }: PaymentMethodProps) {
  return (
    <div className="mt-stack-roomy space-y-stack-roomy">
      <div className="flex items-center space-x-stack">
        <div className="p-stack-tight bg-border rounded-control">
          <svg
            className="w-6 h-6"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect
              x="2"
              y="5"
              width="20"
              height="14"
              rx="2"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        </div>
        <div>
          <div className="font-medium">•••• •••• •••• {data.last4}</div>
          <div className="text-body-sm text-fg-subtle">Expires {data.expiryDate}</div>
        </div>
      </div>

      <Button
        variant="secondary"
        className="w-full"
      >
        Update Payment Method
      </Button>
    </div>
  )
}
